if (!customElements.get('wls-triple-column-info')) {
    class WlsTripleColumnInfoSwiper extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                swiper: 'swiper',
                wrapper: 'swiper-wrapper',
                slide: 'swiper-slide',
            };

            this.elements = {
                slider: null,
                wrapper: null,
                slides: null,
            };
        }

        connectedCallback() {
            this.initElements();
            this.init();
        }

        disconnectedCallback() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
            this.destroySwiper();
        }

        initElements() {
            // Find the .swiper element inside the custom element (parent)
            this.elements.slider = this.querySelector(`.${this.classes.swiper}`);
            this.elements.wrapper = this.querySelector(`.${this.classes.wrapper}`);
            this.elements.slides = this.querySelectorAll(`.${this.classes.slide}`);
        }

        init() {
            if (!this.elements.slider) {
                return;
            }
            if (!this.elements.slides || this.elements.slides.length === 0) {
                return;
            }
            
            // Check initial window width and initialize if mobile
            this.handleResize();
            
            // Listen for window resize to handle responsive behavior
            this.resizeObserver = new ResizeObserver(() => {
                this.handleResize();
            });
            this.resizeObserver.observe(document.body);
        }

        handleResize() {
            const isMobile = window.innerWidth <= 1023;
            
            if (isMobile && !this.swiper) {
                // Initialize Swiper on mobile
                this.initializeSwiper();
            } else if (!isMobile && this.swiper) {
                // Destroy Swiper on desktop
                this.destroySwiper();
            }
        }

        initializeSwiper() {
            // Check if Swiper is available
            if (typeof Swiper === 'undefined') {
                return;
            }
            
            try {
                this.swiper = new Swiper(this.elements.slider, {
                    loop: true,
                    slidesPerView: 1.18,
                    spaceBetween: 16,
                });
            } catch (error) {
                // Swiper initialization failed
            }
        }

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    customElements.define('wls-triple-column-info', WlsTripleColumnInfoSwiper);
}

